import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EngagementHubContainerComponent, EngagementsContainerComponent } from './containers';

const routes: Routes = [
  {
    path: '',
    component: EngagementsContainerComponent,
  },
  {
    path: ':engagementId',
    component: EngagementHubContainerComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EngagementsRoutingModule { }
